import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const AdkPartnersTable = ({ partners, onRemove, onUpdate, onSort }) => {
    const rows = partners.map((partner, index) => <Row key={index} partner={partner} onUpdate={onUpdate} onRemove={onRemove}/>);

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSort('name')}>Name</th>
                    <th onClick={() => onSort('auth')}>Auth</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default AdkPartnersTable;


// WEBPACK FOOTER //
// ./src/scenes/PushapiPartners/components/Table/index.js